export default __webpack_public_path__ + "static/thumbnail-891ff3e390ae6668ee7ec7e69943f68f.png";